module.exports = __webpack_public_path__ + "static/media/panel_black.f6d78c3d.svg";